import { useGradient } from '@statsbomb/kitbag-datavis';
import { normaliseObv } from '@/utils/obv';

export const useObvScale = () => {
  const { gradientScale } = useGradient('divergent');

  return (obv: number) => gradientScale(normaliseObv(obv));
};
